export const BankAccountType = [
  { label: '普通預金', value: '01' },
  { label: '当座預金', value: '02' },
];
